import { Icon, TextAction } from '@leagueplatform/genesis-core';
import React from 'react';

export default function BackToAcctMgmt(props: any) {
  const { customOnClick } = props;

  const styles = {
    color: '$onSurfaceIconPrimary',
    margin: '$quarter $none $two $minusTwoAndHalf', // top right bottom left
    textAlign: 'left',
    fontSize: '$headingThree',
    fontWeight: 'Bold', // 700
    '@tablet': {
      fontSize: '$headingFour',
    },
    '@mobile': {
      fontSize: '$headingFour',
    },
    letterSpacing: 0.25,
  };

  return (
    <TextAction as="button" onClick={customOnClick} css={styles}>
      <Icon
        icon="tinyBackButton"
        size="$one"
        css={{ marginRight: '$oneAndHalf' }}
      />
      Back to Account Management
    </TextAction>
  );
}
